<div class="maintenance-page">
  <h1>We'll be right back</h1>
  <p>ESHYFT is undergoing scheduled maintenance. Please check back shortly.</p>
</div>
